import * as React from 'react'
import { Link } from 'react-router-dom'
import Button from 'ui/atoms/Button'
import Flex from 'ui/atoms/Flex'

import { useAuthContext } from '../../auth/authContext'
import Icons from '../../ui/Icons'
import { ZentakeContext } from '../../utils/ZentakeContext'

function Lockdown({ children }) {
  const { logout, isAuthenticated } = useAuthContext()
  const {
    tabletModeLockDown,
    kioskModeLockDown,
    setTabletModeLockDown,
    setKioskModeLockDown,
  } = React.useContext(ZentakeContext)

  const onUnlock = React.useCallback(() => {
    logout()
    setTabletModeLockDown(false)
    setKioskModeLockDown(false)
  }, [logout, setTabletModeLockDown, setKioskModeLockDown])

  return tabletModeLockDown || kioskModeLockDown ? (
    <div className="absolute top-0 right-0 bottom-0 left-0 bg-gray-800 flex flex-col items-center justify-center">
      <Icons.LockClosed color="text-light-10" size="28" />
      <h3 className="text-light-70 m-4 text-center font-medium text-lg">
        This page is locked. Log in again to unlock it.
      </h3>
      <Flex $horizontalSpacing="medium">
        <Button $active className="text-light-70" onClick={onUnlock}>
          Unlock
        </Button>
        {tabletModeLockDown && isAuthenticated && (
          <Button $active className="text-light-70 transition">
            <Link className="hover:no-underline hover:text-light-70" to="/t">
              Back to Tablet
            </Link>
          </Button>
        )}
      </Flex>
    </div>
  ) : (
    children
  )
}

export default Lockdown
